import { getTransactionKind, getTransferAccounts, TRANSACTION_KINDS } from "./transaction-types";

const CLONE_OMIT_FIELDS = [
  "id",
  "user_id",
  "tenant_id",
  "encrypted_payload",
  "iv",
  "created_at",
  "updated_at",
  "deleted_at",
  "rowType",
  "transaction",
  "transferPair",
  "transactionAmount",
  "previousBalance",
  "balanceAfter",
  "affectsStatementBalance",
  "amount_sign",
  "recurrence_id",
  "recurrence_type",
  "recurrence_frequency",
  "recurrence_interval",
  "installment_index",
  "total_installments",
  "amount_mode",
  "installment_start_index",
  "fixed_total_occurrences",
  "linked_transfer_id",
  "transfer_role",
  "status",
  "confirmed",
  "reconciled",
  "realized_at",
];

function omitCloneFields(transaction = {}) {
  const clone = { ...transaction };
  CLONE_OMIT_FIELDS.forEach((field) => {
    delete clone[field];
  });
  return clone;
}

function cloneDate(value) {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? new Date() : new Date(date.getTime());
}

function cleanInstallmentSuffix(description = "") {
  return String(description || "").replace(/\s*\(\d+\/\d+\)$/, "");
}

function cloneDetails(details) {
  if (!Array.isArray(details)) return undefined;
  return details.map(({ id, ...detail }) => ({ ...detail }));
}

export function prepareTransactionClone(transaction = {}, options = {}) {
  const kind = getTransactionKind(transaction);
  const date = cloneDate(options.now || new Date());
  const clean = omitCloneFields(transaction);
  const details = cloneDetails(transaction.details);
  const baseDescription = cleanInstallmentSuffix(
    transaction.transfer_description || transaction.description || ""
  );

  const clone = {
    ...clean,
    description: baseDescription,
    amount: transaction.amount,
    date,
  };

  if (details) {
    clone.details = details;
  }

  if (kind === TRANSACTION_KINDS.DETAILED) {
    clone.transaction_kind = TRANSACTION_KINDS.DETAILED;
    clone.type = transaction.type || TRANSACTION_KINDS.EXPENSE;
    return clone;
  }

  if (kind === TRANSACTION_KINDS.TRANSFER) {
    const transferAccounts = getTransferAccounts(transaction, options.linkedTransfer);
    const fromAccount = transferAccounts.fromAccount || transaction.from_account || transaction.account || "";
    const toAccount = transferAccounts.toAccount || transaction.to_account || "";
    const fromAccountId = transaction.from_account_id || (transaction.type === "expense" ? transaction.account_id : options.linkedTransfer?.account_id) || null;
    const toAccountId = transaction.to_account_id || (transaction.type === "income" ? transaction.account_id : options.linkedTransfer?.account_id) || null;

    return {
      ...clone,
      type: TRANSACTION_KINDS.EXPENSE,
      transaction_kind: TRANSACTION_KINDS.TRANSFER,
      description: baseDescription || "TRANSFERÊNCIA",
      transfer_description: baseDescription || "TRANSFERÊNCIA",
      account: fromAccount,
      account_id: fromAccountId,
      from_account: fromAccount,
      to_account: toAccount,
      from_account_id: fromAccountId,
      to_account_id: toAccountId,
    };
  }

  delete clone.transaction_kind;
  return clone;
}
